<div class="min-w-[320px] max-w-[400px] overflow-hidden rounded-xl bg-white shadow-lg">
    <!-- Header -->
    <div
        class="relative flex h-[72px] items-center justify-center border-b border-solid border-gray-300 bg-white px-6 py-5 dark:border-contrast-yellow">
        <h2 class="m-0 text-center text-lg font-semibold leading-none text-black dark:text-contrast-yellow">
            {{ 'SELECT_ACCOUNT' | translate }}
        </h2>
        <button
            class="absolute right-6 top-1/2 flex h-8 w-8 -translate-y-1/2 items-center justify-center rounded-full text-grey-zambezy focus:outline-none focus:ring-0 dark:text-contrast-yellow"
            [attr.aria-label]="'CLOSE_ARIA_LABEL' | translate"
            (click)="onClose()">
            <ion-icon
                class="h-8 w-8 text-3xl"
                aria-hidden="true"
                src="{{ assetsPath$ | async }}/img/purchase-flow-v2/areas/close.svg"></ion-icon>
        </button>
    </div>

    <!-- Account Options - Only show when data is loaded -->
    <div class="overflow-y-auto p-0" *ngIf="(allAccountDataLoading$ | async) === false">
        <div
            class="mx-4 flex h-14 cursor-pointer items-center gap-2 border-b border-solid border-gray-300 transition-colors duration-200 last:border-b-0 hover:bg-gray-50 dark:border-contrast-yellow"
            *ngFor="let account of accountsWithDisplayData$ | async"
            [class.cursor-not-allowed]="!account.isActive"
            (click)="onAccountSelect(account.id)">
            <!-- Custom Radio Button -->
            <div
                class="relative -mt-px flex h-8 w-8 flex-shrink-0 items-center justify-center"
                [class.high-contrast]="isContrast$ | async">
                <input
                    class="absolute h-full w-full cursor-pointer opacity-0"
                    [value]="account.id"
                    [checked]="account.isSelected"
                    [disabled]="!account.isActive"
                    [attr.aria-labelledby]="'account-name-' + account.id"
                    (change)="onAccountSelect(account.id)"
                    type="radio"
                    name="accountSelector" />
                <div class="radio-custom"></div>
            </div>

            <!-- Account Icon -->
            <ion-icon
                class="h-8 w-8 flex-shrink-0 text-3xl text-grey-zambezy dark:text-contrast-yellow"
                [class.opacity-50]="!account.isActive"
                [src]="
                    (assetsPath$ | async) +
                    '/img/purchase-flow-v2/areas/' +
                    (account.typeCode === 'PERSONAL' ? 'personal' : 'corporate') +
                    '.svg'
                "
                aria-hidden="true">
            </ion-icon>

            <!-- Account Name -->
            <span
                class="flex-1 text-base font-medium text-black dark:text-contrast-yellow"
                [class.opacity-50]="!account.isActive"
                [id]="'account-name-' + account.id"
                aria-hidden="true">
                <!-- For non-personal accounts with organization, show organization name -->
                <span *ngIf="account.isNonPersonal && account.organization">
                    {{ account.organization.name }}
                </span>

                <!-- For personal accounts or when organization is not available, use account type -->
                <span *ngIf="!account.isNonPersonal || !account.organization">
                    {{ account.name | translateObjectField: null : locale : account.typeCode }}
                </span>
            </span>

            <!-- Blocked Label -->
            <div
                class="text-primary-danger ml-auto flex flex-shrink-0 items-center text-sm font-medium dark:text-contrast-yellow"
                *ngIf="!account.isActive">
                <ion-icon
                    class="mr-1.5 h-4 w-4"
                    aria-hidden="true"
                    src="{{ assetsPath$ | async }}/img/purchase-flow-v2/areas/blocked.svg"></ion-icon>
                <span class="whitespace-nowrap uppercase">{{ 'BLOCKED' | translate }}</span>
            </div>
        </div>
    </div>
</div>
